import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import PrenotazionePubblica from "./pages/PrenotazionePubblica";
import Oggi from "./pages/Oggi";
import Prenotazioni from "./pages/Prenotazioni";
import PrenotazioneDettaglio from "./pages/PrenotazioneDettaglio";
import Sala from "./pages/Sala";
import Clienti from "./pages/Clienti";
import ClienteDettaglio from "./pages/ClienteDettaglio";
import Coupon from "./pages/Coupon";
import GiftCards from "./pages/GiftCards";
import Scanner from "./pages/Scanner";
import Marketing from "./pages/Marketing";
import ModuliWeb from "./pages/ModuliWeb";
import ModuloEditor from "./pages/ModuloEditor";
import ModuloPubblico from "./pages/ModuloPubblico";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import LegalPubblica from "./pages/LegalPubblica";
import Disiscrizione from "./pages/Disiscrizione";
import CouponPubblico from "./pages/CouponPubblico";
import Sondaggi from "./pages/Sondaggi";
import Automazioni from "./pages/Automazioni";
import Centralino from "./pages/Centralino";
import Upgrade from "./pages/Upgrade";
import Menu from "./pages/Menu";
import Statistiche from "./pages/Statistiche";
import Impostazioni from "./pages/Impostazioni";
import Integrazioni from "./pages/Integrazioni";
import SurveyPublic from "./pages/SurveyPublic";
import FidelityCard from "./pages/FidelityCard";
import FidelityJoin from "./pages/FidelityJoin";
import Haccp from "./pages/Haccp";
import PublicBooking from "./pages/PublicBooking";
import MenuPubblico from "./pages/MenuPubblico";
import PaymentEsito from "./pages/PaymentEsito";
import EventLanding from "./pages/EventLanding";
import Eventi from "./pages/Eventi";
import Promozioni from "./pages/Promozioni";
import Fidelity from "./pages/Fidelity";
import Strumenti from "./pages/Strumenti";
import Sospeso from "./pages/Sospeso";
import SALayout from "./components/SALayout";
import SADashboard from "./pages/superadmin/SADashboard";
import SARistoranti from "./pages/superadmin/SARistoranti";
import SARistoranteDettaglio from "./pages/superadmin/SARistoranteDettaglio";
import SAPiani from "./pages/superadmin/SAPiani";
import SAAbbonamenti from "./pages/superadmin/SAAbbonamenti";
import SAPagamenti from "./pages/superadmin/SAPagamenti";
import SAEventi from "./pages/superadmin/SAEventi";
import SAImpostazioni from "./pages/superadmin/SAImpostazioni";
import SAIntegrazioni from "./pages/superadmin/SAIntegrazioni";
import SABranding from "./pages/superadmin/SABranding";
import SAComunicazioni from "./pages/superadmin/SAComunicazioni";
import RichiediInfo from "./pages/RichiediInfo";
import Vetrina from "./pages/Vetrina";
import Locali from "./pages/Locali";
import LocaleDettaglio from "./pages/LocaleDettaglio";
import Coda from "./pages/Coda";
import CodaPubblica from "./pages/CodaPubblica";
import WaCallback from "./pages/WaCallback";

function ProtectedSA() {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <span className="font-display font-extrabold text-2xl text-zinc-700">DISHENDA</span>
    </div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "superadmin") return <Navigate to="/" replace />;
  return <SALayout />;
}

const SALA_ALLOWED = ["/", "/prenotazioni", "/sala", "/clienti", "/fidelity", "/gift-card", "/scanner", "/coda", "/haccp"];

// Sul dominio root (dishenda.it) la home mostra il sito vetrina; il gestionale resta su app.dishenda.it
const MARKETING_HOSTS = ["dishenda.it", "www.dishenda.it"];
// Sul sottodominio prenota.dishenda.it la home mostra il portale dei locali (marketplace)
const PORTAL_HOSTS = ["prenota.dishenda.it"];

// Redirect per i vecchi link /m/:rid/:slug finiti in alcune campagne (schema corretto: /p/:rid/m/:slug)
function LegacyModuloRedirect() {
  const { rid, slug } = useParams();
  return <Navigate to={`/p/${rid}/m/${slug}`} replace />;
}

function Protected() {
  const { user } = useAuth();
  const location = useLocation();
  const host = window.location.hostname;
  if (PORTAL_HOSTS.includes(host) && location.pathname === "/") {
    return <Locali />;
  }
  if (MARKETING_HOSTS.includes(host) && location.pathname === "/") {
    return <Vetrina />;
  }
  if (user === null) {
    return <div className="min-h-screen bg-zinc-100 flex items-center justify-center">
      <span className="font-display font-extrabold text-2xl text-zinc-300">DISHENDA</span>
    </div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "superadmin") return <Navigate to="/superadmin" replace />;
  if (user.role === "sala" && !SALA_ALLOWED.some((p) =>
    p === "/" ? location.pathname === "/" : location.pathname === p || location.pathname.startsWith(p + "/"))) {
    return <Navigate to="/" replace />;
  }
  return <Layout />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandingProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/s/:token" element={<SurveyPublic />} />
            <Route path="/p/:rid" element={<PublicBooking />} />
          <Route path="/p/:rid/menu" element={<MenuPubblico />} />
          <Route path="/pagamento/esito" element={<PaymentEsito />} />
            <Route path="/p/:rid/e/:slug" element={<EventLanding />} />
          <Route path="/p/:rid/m/:slug" element={<ModuloPubblico />} />
          <Route path="/m/:rid/:slug" element={<LegacyModuloRedirect />} />
          <Route path="/coda/:token" element={<CodaPubblica />} />
          <Route path="/fidelity/:token" element={<FidelityCard />} />
          <Route path="/fidelity-join/:rid" element={<FidelityJoin />} />
          <Route path="/whatsapp-callback" element={<WaCallback />} />
          <Route path="/p/:rid/c/:slug" element={<CouponPubblico />} />
            <Route path="/prenotazione/:token" element={<PrenotazionePubblica />} />
            <Route path="/sospeso" element={<Sospeso />} />
            <Route path="/richiedi-info" element={<RichiediInfo />} />
            <Route path="/vetrina" element={<Vetrina />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/p/:rid/privacy" element={<LegalPubblica tipo="privacy" />} />
            <Route path="/p/:rid/cookie" element={<LegalPubblica tipo="cookie" />} />
            <Route path="/disiscrivi/:token" element={<Disiscrizione />} />
            <Route path="/locali" element={<Locali />} />
            <Route path="/locali/:rid" element={<LocaleDettaglio />} />
            <Route path="/superadmin" element={<ProtectedSA />}>
              <Route index element={<SADashboard />} />
              <Route path="ristoranti" element={<SARistoranti />} />
              <Route path="ristoranti/:id" element={<SARistoranteDettaglio />} />
              <Route path="piani" element={<SAPiani />} />
              <Route path="abbonamenti" element={<SAAbbonamenti />} />
              <Route path="pagamenti" element={<SAPagamenti />} />
              <Route path="eventi" element={<SAEventi />} />
              <Route path="integrazioni" element={<SAIntegrazioni />} />
              <Route path="branding" element={<SABranding />} />
              <Route path="comunicazioni" element={<SAComunicazioni />} />
              <Route path="impostazioni" element={<SAImpostazioni />} />
            </Route>
            <Route element={<Protected />}>
              <Route path="/" element={<Oggi />} />
              <Route path="/prenotazioni" element={<Prenotazioni />} />
              <Route path="/prenotazioni/:id" element={<PrenotazioneDettaglio />} />
              <Route path="/sala" element={<Sala />} />
              <Route path="/clienti" element={<Clienti />} />
              <Route path="/clienti/:id" element={<ClienteDettaglio />} />
              <Route path="/coupon" element={<Coupon />} />
              <Route path="/gift-card" element={<GiftCards />} />
              <Route path="/haccp" element={<Haccp />} />
              <Route path="/scanner" element={<Scanner />} />
              <Route path="/marketing" element={<Marketing />} />
              <Route path="/promozioni" element={<Promozioni />} />
              <Route path="/eventi" element={<Eventi />} />
              <Route path="/moduli" element={<ModuliWeb />} />
              <Route path="/moduli/:id" element={<ModuloEditor />} />
              <Route path="/coda" element={<Coda />} />
              <Route path="/fidelity" element={<Fidelity />} />
              <Route path="/strumenti" element={<Strumenti />} />
              <Route path="/sondaggi" element={<Sondaggi />} />
              <Route path="/automazioni" element={<Automazioni />} />
              <Route path="/centralino" element={<Centralino />} />
              <Route path="/upgrade" element={<Upgrade />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/statistiche" element={<Statistiche />} />
              <Route path="/impostazioni" element={<Impostazioni />} />
              <Route path="/integrazioni" element={<Integrazioni />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </BrowserRouter>
          <Toaster position="bottom-center" richColors />
        </BrandingProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
